/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
export enum toasterOptions {
	info = "info",
	success = "success",
	warning = "warning",
	error = "error",
}
